import {constants} from '@neosvoc/nv-platform-core-common';
import flatten from 'lodash/flatten';
import map from 'lodash/map';

const conditionBuilders = {
    [constants.EDITOR_TEMPLATES.STRING_1]: () => ({operator: constants.EDITOR_OPERATORS.EQ, value: ''}),
    [constants.EDITOR_TEMPLATES.NUMBER_1]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.NUMBER_2]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: '', question: ''}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: '', question: ''}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: '', question: ''}),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1]: () => ({operator: constants.EDITOR_OPERATORS.IN, value: ''}),
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2]: () => ({operator: constants.EDITOR_OPERATORS.IN, value: ''}),
    [constants.EDITOR_TEMPLATES.BATTERY_1]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: '', question: ''}),
    [constants.EDITOR_TEMPLATES.BATTERY_2]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: '', question: ''}),
    [constants.EDITOR_TEMPLATES.DATE_1]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}), // Same as singleChoice
    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}), // Same as singleChoice
    // No conditions supported for these types
    [constants.EDITOR_TEMPLATES.GEO_1]: () => false,
    [constants.EDITOR_TEMPLATES.IMAGE_1]: () => false,
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT]: () => false,
    [constants.EDITOR_TEMPLATES.TEXT_1]: () => false,
    [constants.EDITOR_TEMPLATES.RANK_1]: () => ({operator: constants.EDITOR_OPERATORS.LT, value: ''}),
    [constants.EDITOR_VARIABLES.PARAMETERS]: () => ({operator: constants.EDITOR_OPERATORS.EQ, value: ''}),
    [constants.EDITOR_VARIABLES.EXTRA_FIELDS]: () => ({operator: constants.EDITOR_OPERATORS.EQ, value: ''}),

};

const supportsExpression = (item) => item && item.id && conditionBuilders[item.type] && conditionBuilders[item.type]();

const previousQuestions = (previousPages) => flatten(map(previousPages || [], 'items')).filter(supportsExpression);

const previousQuestionsSupportingExpressions = (previousPages) => previousQuestions(previousPages).filter(supportsExpression);

export {supportsExpression, previousQuestionsSupportingExpressions};
export default conditionBuilders;
